import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { homeLayout } from './layout';
import {
  featuredDocsWidget,
  starredEntitiesWidget,
  toolkitWidget,
} from './widgets';

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [
    homeLayout,
    featuredDocsWidget,
    toolkitWidget,
    starredEntitiesWidget,
  ],
});
